import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, CloseButton, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { PageHeader, Pagination } from '../../components';
import CheckableDataTable from '../../components/CheckableDataTable/CheckableDataTable';
import useComponentState from './../../utils/useComponentState';
import {
  getVouchersByStatus,
  getTransactions,
  searchVouchers,
  activateVoucher,
  updateVoucherDetails,
} from '../../api/Vouchers';
import { getAllTiers } from '../../api/events';
import { toast } from 'react-toastify';
import { validateMobileNumber } from '../../utils/validations';
import { isPossiblePhoneNumber } from 'react-phone-number-input';
import InputGroup from 'react-bootstrap/InputGroup';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import moment from 'moment';
import { Drawer } from 'rsuite';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import {
  faSearch,
  faTimes,
  faEdit,
  faCheck,
  faSpinner,
  faDownload,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import VoucherActivationModal from '../../components/Modals/VoucherActivationModal';
import VoucherExtensionModal from '../../components/Modals/VoucherExtensionModal';
import MerchantCodesModal from '../../components/Modals/MerchantCodesModal';
import DataTable from '../../components/DataTable/DataTable';
import { usePermissions } from '../../hooks/usePermissions';
import PermissionGate from '../../components/PermissionGate/PermissionGate';
import { POINT_ACCOUNT_PERMISSIONS } from '../../constants/permissions';

import styles from './ViewVouchers.module.scss';

// Point Account view table columns (fixed for all roles).
const buildTableHeading = () => ({
  column: [
    'Reward ID',
    'Created Date',
    'Amount',
    'Member Mobile',
    'Tier',
    'Redeemable Points',
  ],
});

// Point Account view search dropdown options (fixed for all roles).
const buildSearchDropdown = () => [
  { key: 'id', label: 'Reward ID', placeholder: 'Reward ID' },
  { key: 'mobile_no', label: 'Member Mobile', placeholder: 'Member Mobile' },
  { key: 'created_date', label: 'Created Date', placeholder: 'YYYY-MM-DD' },
];

const ViewVouchers = (props) => {
  const { can } = usePermissions();

  /* const dispatch = useDispatch(); */
  const [state, setState] = useComponentState({
    tableHeading: buildTableHeading(),
    voucherData: [],
    transactionDetails: [],
    merchantCodesDetails: [],
    transactionHeading: {
      column: ['Date', 'Description', 'Type', 'Amount'],
    },
    tabItems: {
      status: [
        { key: 'ALL', label: 'All' },
        { key: 'ACTIVE', label: 'Active' },
        { key: 'INACTIVE', label: 'Inactive' },
      ],
      searchDropDown: buildSearchDropdown(),
    },
    label: 'Reward ID',
    searchPlaceholder: 'Reward ID',
    // tier filter
    tiers: [],
    selectedTierId: '',
    tierLabel: 'All Tiers',
    // edit helpers for inline editing in drawer
    editingField: null, // e.g. 'ownerMobile'
    editReceiverMobile: '',
    editFieldErrors: {},
    editMobileLoading: false,
    currentPage: 0,
    pageSize: 100,
    searchId: 'id',
    receiverName: '',
    receiverMobile: '',
    searchKey: '',
    statusKey: 'ALL',
    voucherId: '',
    notFoundMessage: '',
    fetchError: '',
    loading: false,
    totalPages: 0,
    showVoucherDrawer: false,
    drawerData: null,
    isClearable: false,
    page: 1,
    activationLoading: false,
    mobileError: '',
    validated: false,
    showActivationModal: false,
    activationError: '',
    userName: '',
    activationSuccess: false,
    extensionSuccess: false,
    isSelected: false,
    selectAll: false,
    checkedRows: [],
    showExtensionModal: false,
    renderDatePicker: false,
    extensionDate: '',
    extensionLabel: '',
    voucherExpiryDate: null,
    selectedRedemptionId: null,
    showTransactions: false,
    transactionError: '',
    transactionLoading: false,
    selectedTransaction: null,
    showMerchantCodesModal: false,
    downloadStatus: '',
  });
  const {
    tableHeading,
    voucherData,
    label,
    loading,
    totalPages,
    currentPage,
    pageSize,
    receiverName,
    receiverMobile,
    searchPlaceholder,
    searchId,
    showVoucherDrawer,
    drawerData,
    searchKey,
    isClearable,
    tabItems,
    statusKey,
    fetchError,
    voucherId,
    activationLoading,
    mobileError,
    validated,
    showActivationModal,
    activationError,
    activationSuccess,
    isSelected,
    selectAll,
    checkedRows,
    showExtensionModal,
    voucherExpiryDate,
    selectedRedemptionId,
    showTransactions,
    transactionError,
    transactionLoading,
    transactionDetails,
    editingField,
    editReceiverMobile,
    editFieldErrors,
    editMobileLoading,
    selectedTransaction,
    showMerchantCodesModal,
    transactionHeading,
    downloadStatus,
    tiers,
    selectedTierId,
    tierLabel,
  } = state;

  useEffect(() => {
    !searchKey && getVoucherDetails(0);
    //eslint-disable-next-line
  }, [statusKey]);

  useEffect(() => {
    handleGetTiers();
    //eslint-disable-next-line
  }, []);

  const handleGetTiers = async () => {
    try {
      const response = await getAllTiers(0, props.auth.auth.token);
      setState({ tiers: Array.isArray(response) ? response : [] });
    } catch (error) {
      setState({ tiers: [] });
    }
  };

  const searchByTier = async (page, tierId) => {
    setState({ loading: true, voucherData: [], fetchError: '', statusKey: 'ALL' });
    try {
      const request = {
        searchKey: '',
        searchId: searchId,
        page: page,
        pageSize: pageSize,
        sortBy: 'created_date',
        order: 'desc',
        loyaltyTierId: Number(tierId),
      };
      const token = props.auth.auth.token;
      const response = await searchVouchers(request, token);
      setState({
        voucherData: response.list,
        totalPages: response.totalPageCount,
        currentPage: response.pageNo,
      });
    } catch (error) {
      setState({ fetchError: 'Oops, something went wrong. Please try again' });
    }
    setState({ loading: false });
  };

  const handleTierSelect = (tierId, tierName) => {
    setState({
      selectedTierId: tierId,
      tierLabel: tierId ? tierName : 'All Tiers',
      currentPage: 0,
    });
    if (tierId) {
      searchByTier(0, tierId);
    } else {
      getVoucherDetails(0);
    }
  };

  const handleTierClear = () => {
    handleTierSelect('', 'All Tiers');
  };

  const handleShowMerchantCodes = () => {
    setState({ showMerchantCodesModal: true, showVoucherDrawer: false });
  };

  const handleMerchantModalClose = () => {
    setState({
      showMerchantCodesModal: !showMerchantCodesModal,
      showVoucherDrawer: false,
      selectedTransaction: null,
    });
  };

  const renderTransactionDetails = (data) => {
    const handleClose = () => {
      // hide the transactions view and clear the selected transaction
      setState({
        showTransactions: true,
        selectedTransaction: null,
      });
    };

    const transaction = data;
    const transactionContent = [
      { label: 'Transaction Type', value: transaction.transactionType },
      { label: 'Description', value: transaction.description },
      { label: 'Amount', value: transaction.amount.toFixed(2) },
      {
        label: 'Running Balance',
        value: transaction.runningBalance.toFixed(2),
      },
      {
        label: 'Timestamp',
        value: moment(transaction.timestamp).format('DD/MM/YYYY hh:mm A'),
      },
      { label: 'Redemption ID', value: transaction.redemptionId },
      { label: 'Merchant', value: transaction.merchant },
      { label: 'Sub-Merchant', value: transaction.subMerchant },
      { label: 'Reference Code', value: transaction.referenceCode },
      { label: 'Status', value: transaction.status },
    ];

    const filteredTransactionSectionContent = transactionContent.filter(
      (item) =>
        item.value !== null && item.value !== undefined && item.value !== ''
    );

    return (
      <div className={`details_group ${styles.content}`}>
        <Card>
          <Card.Body>
            <div className={styles.header}>
              <button className={styles.closeButton} onClick={handleClose}>
                &times;
              </button>
            </div>
            {filteredTransactionSectionContent.map((item, index) => (
              <div
                key={index}
                className='detail_group_content'
                style={{ height: '1rem' }}
              >
                <span className='content_header'>{item.label}</span>
                <span
                  className='content_value'
                  style={item.style && item.style}
                >
                  {item.value ? item.value : 'N/A'}
                </span>
              </div>
            ))}
          </Card.Body>
        </Card>
      </div>
    );
  };

  // Edit helpers for receiver mobile (ownerMobile)
  const handleEditFieldStart = (field) => {
    if (!drawerData) return;
    if (field !== 'ownerMobile') return;
    setState({ editingField: field, editReceiverMobile: drawerData.ownerMobile || '', editFieldErrors: {} });
  };

  const handleEditFieldCancel = (field) => {
    setState({ editingField: null, editReceiverMobile: '', editFieldErrors: {} });
  };

  const handleEditFieldChange = (value) => {
    setState({ editReceiverMobile: value, editFieldErrors: { ...state.editFieldErrors, ownerMobile: '' } });
  };

  const handleEditFieldSave = async () => {
    if (!can(POINT_ACCOUNT_PERMISSIONS.POINT_ACCOUNT.UPDATE)) {
      toast.error('You are not authorized to perform this action.');
      return;
    }
    // only ownerMobile supported here
    const newMobile = state.editReceiverMobile;
    const validation = validateMobileNumber(newMobile);
    if (!validation.isValid) {
      toast.error(validation.error);
      return;
    }

    try {
      setState({ editMobileLoading: true });
      const token = props.auth.auth.token;
      // payload uses ownerMobile to match existing data model
      await updateVoucherDetails(drawerData.id, { receiverMobileNo: newMobile }, token);

      // optimistic: if response exists, assume success
      setState((prev) => ({
        ...prev,
        editingField: null,
        editReceiverMobile: '',
        editFieldErrors: {},
        editMobileLoading: false,
        drawerData: {
          ...prev.drawerData,
          ownerMobile: newMobile,
        },
        // also update list if present
        voucherData: prev.voucherData.map((v) => (v.id === prev.drawerData.id ? { ...v, ownerMobile: newMobile } : v)),
      }));
      toast.success('Receiver mobile updated successfully');
    } catch (error) {
      setState({ editMobileLoading: false });
      toast.error('Failed to update receiver mobile');
    }
  };

  const exportToCSV = (csvData, fileName) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + '.xlsx');
  };

  const fetchAllRecords = async (token) => {
    const downloadPageSize = 100;
    let allRecords = [];
    if (selectedTierId) {
      const baseRequest = {
        searchKey: '',
        searchId,
        page: 0,
        pageSize: downloadPageSize,
        sortBy: 'created_date',
        order: 'desc',
        loyaltyTierId: Number(selectedTierId),
      };
      const firstResponse = await searchVouchers(baseRequest, token);
      allRecords = firstResponse.list || [];
      const totalPages = firstResponse.totalPageCount || 1;
      for (let page = 1; page < totalPages; page++) {
        const response = await searchVouchers({ ...baseRequest, page }, token);
        allRecords = allRecords.concat(response.list || []);
      }
    } else if (searchKey && isClearable) {
      const baseRequest = { searchKey, searchId, page: 0, pageSize: downloadPageSize, sortBy: 'created_date', order: 'desc' };
      const firstResponse = await searchVouchers(baseRequest, token);
      allRecords = firstResponse.list || [];
      const totalPages = firstResponse.totalPageCount || 1;
      for (let page = 1; page < totalPages; page++) {
        const response = await searchVouchers({ ...baseRequest, page }, token);
        allRecords = allRecords.concat(response.list || []);
      }
    } else {
      const firstResponse = await getVouchersByStatus(token, statusKey, 0, downloadPageSize);
      allRecords = firstResponse.list || [];
      const totalPages = firstResponse.totalPageCount || 1;
      for (let page = 1; page < totalPages; page++) {
        const response = await getVouchersByStatus(token, statusKey, page, downloadPageSize);
        allRecords = allRecords.concat(response.list || []);
      }
    }
    return allRecords;
  };

  const formatRecordsForExport = (records) =>
    records.map((v) => ({
      'Reward ID': v.id,
      'Member Name': v.ownerName || '',
      'Member Mobile': v.ownerMobile || '',
      'Tier': v.loyaltyTier?.name || '',
      'Redeemable Points': v.redeemablePoints ?? '',
      'Amount': v.amount?.toFixed(2) ?? '',
      'Status': v.status || '',
      'Created Date': moment(v.createdDate).format('YYYY-MM-DD HH:mm:ss'),
      'Expiry Date': moment(v.expiryDate).format('YYYY-MM-DD HH:mm:ss'),
    }));

  const handleDownload = async () => {
    setState({ downloadStatus: 'DOWNLOADING' });
    try {
      const token = props.auth.auth.token;
      const allRecords = await fetchAllRecords(token);
      if (allRecords.length === 0) {
        toast.error('No point accounts found to download.');
        setState({ downloadStatus: '' });
        return;
      }
      exportToCSV(formatRecordsForExport(allRecords), 'Point_Accounts');
      setState({ downloadStatus: '' });
    } catch (error) {
      setState({ downloadStatus: 'ERROR' });
    }
  };

  const handleDownloadSelected = async () => {
    setState({ downloadStatus: 'DOWNLOADING_SELECTED' });
    try {
      const token = props.auth.auth.token;
      const allRecords = await fetchAllRecords(token);
      const selectedRecords = allRecords.filter((v) => checkedRows.includes(v.id));
      if (selectedRecords.length === 0) {
        toast.error('No point accounts found to download.');
        setState({ downloadStatus: '' });
        return;
      }
      exportToCSV(
        formatRecordsForExport(selectedRecords),
        'Point_Accounts_Selected'
      );
      setState({ downloadStatus: '' });
    } catch (error) {
      setState({ downloadStatus: 'ERROR' });
    }
  };

  const getTransactionDetails = async (voucherID) => {
    setState({ fetchError: '', transactionError: '' });
    if (!showTransactions) {
      setState({
        transactionLoading: true,
        showTransactions: !showTransactions,
      });
      try {
        const response = await getTransactions(
          props.auth.auth.token,
          voucherID
        );
        setState({
          transactionDetails: response,
        });
        setState({ transactionLoading: false });
      } catch (error) {
        setState({
          transactionError: 'Oops, something went wrong, Please try again.',
          transactionLoading: false,
        });
      }
    } else {
      setState({ transactionDetails: [], showTransactions: !showTransactions });
    }
  };

  const getVoucherDetails = async (currentPage) => {
    setState({ loading: true, voucherData: [], fetchError: '' });
    try {
      const response = await getVouchersByStatus(
        props.auth.auth.token,
        statusKey,
        currentPage,
        pageSize
      );
      setState({
        voucherData: response.list,
        totalPages: response.totalPageCount,
        currentPage: response.pageNo,
      });
    } catch (error) {
      setState({
        fetchError: 'Oops, something went wrong. Please try again',
      });
    }
    setState({ loading: false });
  };

  const handleTabOnClick = (key) => {
    setState({
      statusKey: key,
      searchKey: '',
      isClearable: false,
    });
  };

  const handleShowActivationModal = () => {
    setState({ showActivationModal: true, showVoucherDrawer: false });
  };

  const validatePhoneNumber = (receiverMobile) => {
    if (receiverMobile) {
      if (isPossiblePhoneNumber(receiverMobile)) {
        setState({
          mobileError: '',
        });
      } else {
        setState({
          mobileError: 'Enter a valid mobile number',
        });
      }
    } else {
      setState({
        mobileError: "Mobile number can't be empty",
      });
    }
  };

  const validateDetails = () => {
    validatePhoneNumber(receiverMobile);
    if (
      receiverName &&
      receiverMobile &&
      isPossiblePhoneNumber(receiverMobile)
    ) {
      return true;
    }
    return false;
  };

  const handleActivationSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!can(POINT_ACCOUNT_PERMISSIONS.POINT_ACCOUNT.UPDATE)) {
      toast.error('You are not authorized to perform this action.');
      return;
    }
    const isValidDetails = validateDetails();

    if (!isValidDetails) {
      setState({ validated: true });
    } else {
      setState({ activationLoading: true });
      /* dispatch(setLoading()); */
      try {
        const request = {
          voucherId: voucherId,
          name: receiverName,
          mobileNo: receiverMobile,
        };
        const token = props.auth.auth.token;
        const response = await activateVoucher(request, token);
        if (response && response.status === 'COMPLETE') {
          /* dispatch(setLoading()); */
          setState({
            activationSuccess: true,
            validated: false,
            activationError: '',
            activationLoading: false,
          });
          getVoucherDetails(currentPage);
        }
      } catch (error) {
        setState({
          activationError: 'Oops! Something went wrong. Please try again',
          activationLoading: false,
          activationSuccess: false,
        });
      }
    }
  };

  const handleSearch = () => {
    if (!isClearable) {
      const { searchKey } = state;
      if (searchKey) {
        setState({
          isClearable: true,
        });
        searchVoucherById(0);
      }
    } else {
      handleIdOnClear();
    }
  };

  const handleIdOnClear = () => {
    setState({
      searchKey: '',
      isClearable: false,
      notFoundMessage: null,
    });
    getVoucherDetails(0);
  };

  const handleMobileChange = (receiverMobile) => {
    if (validated) {
      setState({ receiverMobile });
      validatePhoneNumber(receiverMobile);
    } else {
      setState({ receiverMobile });
    }
  };

  const hideActivationModal = () => {
    setState({
      showActivationModal: false,
      voucherId: '',
      mobileError: '',
      validated: false,
      activationError: '',
      activationLoading: false,
      receiverName: '',
      receiverMobile: '',
      activationSuccess: false,
    });
  };

  const toggleExtensionModal = () => {
    setState({
      showExtensionModal: !showExtensionModal,
      showVoucherDrawer: false,
    });
  };

  const handleSearchDropDownOnClick = (key, label, placeholder) => {
    getVoucherDetails(0);
    setState({
      label: label,
      searchPlaceholder: placeholder,
      searchId: key,
      searchKey: '',
      isClearable: false,
    });
  };

    const handleCheckBoxToggle = (rowId, event) => {
    event.stopPropagation();
    handleCheck(rowId);
  };

  const handleCheck = (rowId) => {
    if (checkedRows.includes(rowId)) {
      const updatedCheckedRows = checkedRows.filter((id) => id !== rowId);
      setState({ checkedRows: updatedCheckedRows });
    } else {
      setState({ checkedRows: [...checkedRows, rowId] });
    }
  };

  const handleMultipleCheck = (ids) => {
    setState((prev) => {
      const checkedSet = new Set(prev.checkedRows);
 
      ids.forEach((id) => {
        if (checkedSet.has(id)) {
          checkedSet.delete(id);
        } else {
          checkedSet.add(id);
        }
      });
 
      return {
        ...prev,
        checkedRows: Array.from(checkedSet),
      };
    });
  };

  const handleSelectAll = (event) => {
    setState({ selectAll: event.target.checked });
    if (event.target.checked) {
      const selectedAll = voucherData.map((data) => data.id);
      setState({ checkedRows: [...new Set([...checkedRows, ...selectedAll])] });
    } else {
      const updatedCheckedRows = checkedRows.filter(
        (id) => !voucherData.some((data) => data.id === id)
      );
      setState({ checkedRows: updatedCheckedRows });
    }
  };

  const searchOnChange = (event) => {
    const { searchId } = state;
    const inputValue = event.target.value;
    switch (searchId) {
      case 'mobile_no':
        /^\+?[0-9]*$/.test(inputValue) &&
          setState({
            searchKey: event.target.value,
            isClearable: false,
          });
        break;
      case 'id':
      case 'purchase':
        /^[a-zA-Z0-9]*$/.test(inputValue) &&
          setState({
            searchKey: event.target.value,
            isClearable: false,
          });
        break;
      case 'receiver_name':
      case 'sender_name':
        let str = inputValue.replace(/^\s+/, '');
        setState({
          searchKey: str,
          isClearable: false,
        });
        break;
      case 'created_date':
      case 'expiry_date':
        let formattedDate = inputValue.replace(/[^0-9]/g, '');
        if (formattedDate.length > 8) {
          formattedDate = formattedDate.substring(0, 8);
        }
        if (formattedDate.length > 6) {
          formattedDate = formattedDate.replace(
            /^([0-9]{4})([0-9]{2})/,
            '$1-$2-'
          );
        } else if (formattedDate.length > 4) {
          formattedDate = formattedDate.replace(/^([0-9]{4})/, '$1-');
        }
        setState({
          searchKey: formattedDate,
          isClearable: false,
        });
        break;
      default:
        setState({
          searchKey: event.target.value,
          isClearable: false,
        });
    }
  };

  const searchVoucherById = async (page) => {
    setState({
      loading: true,
      fetchError: '',
      statusKey: 'ALL',
    });
    try {
      const request = {
        searchKey: searchKey,
        searchId: searchId,
        page: page,
        pageSize: pageSize,
        sortBy: 'created_date',
        order: 'desc',
      };
      const token = props.auth.auth.token;
      const response = await searchVouchers(request, token);
      setState({
        voucherData: response.list,
        totalPages: response.totalPageCount,
        currentPage: response.pageNo,
      });
    } catch (error) {
      setState({
        fetchError: 'Oops, something went wrong. Please try again',
      });
    }
    setState({ loading: false });
  };

  const isTierFilterActive = !!selectedTierId;
  const isSearchFilterActive = isClearable;
  const isAnyFilterActive = isTierFilterActive || (searchKey && isClearable);

  const renderClearFilterButton = ({ onClick, disabled }) => (
    <InputGroup.Append>
      <Button
        variant='secondary'
        onClick={onClick}
        disabled={disabled}
        className={styles.clear_filter_btn}
      >
        <FontAwesomeIcon icon={faTimes} />
      </Button>
    </InputGroup.Append>
  );

  const renderMultipleSearch = () => {
    return (
      <InputGroup className='mb-3'>
        <DropdownButton
          as={InputGroup.Prepend}
          variant='secondary'
          title={label}
          id='input-group-dropdown-1'
          disabled={isTierFilterActive}
        >
          {tabItems.searchDropDown.map((item) => {
            const { key, label, placeholder } = item;
            return (
              <Dropdown.Item
                key={key}
                onClick={() =>
                  handleSearchDropDownOnClick(key, label, placeholder)
                }
              >
                {label}
              </Dropdown.Item>
            );
          })}
        </DropdownButton>
        <Form.Control
          placeholder={searchPlaceholder}
          value={searchKey}
          onChange={searchOnChange}
          required
          maxLength={50}
          disabled={isTierFilterActive}
        />
        <InputGroup.Append>
          <Button
            variant='secondary'
            onClick={handleSearch}
            disabled={isTierFilterActive}
          >
            <FontAwesomeIcon icon={isClearable ? faTimes : faSearch} />
          </Button>
        </InputGroup.Append>
      </InputGroup>
    );
  };

  const renderTierFilter = () => {
    return (
      <InputGroup className='mb-3'>
        <InputGroup.Prepend>
          <InputGroup.Text>Tier</InputGroup.Text>
        </InputGroup.Prepend>
        <DropdownButton
          as={InputGroup.Append}
          variant='secondary'
          title={tierLabel}
          id='tier-filter-dropdown'
          disabled={isSearchFilterActive}
        >
          <Dropdown.Item onClick={() => handleTierSelect('', 'All Tiers')}>
            All Tiers
          </Dropdown.Item>
          {tiers.map((tier) => (
            <Dropdown.Item
              key={tier.id}
              onClick={() => handleTierSelect(tier.id, tier.name)}
            >
              {tier.name}
            </Dropdown.Item>
          ))}
        </DropdownButton>
        {isTierFilterActive &&
          renderClearFilterButton({
            onClick: handleTierClear,
            disabled: isSearchFilterActive,
          })}
      </InputGroup>
    );
  };

  const renderFilterByStatus = () => {
    const { statusKey, tabItems } = state;
    return (
      <Breadcrumb>
        {tabItems.status.map((item) => {
          const { key, label } = item;
          return (
            <Breadcrumb.Item
              key={key}
              active={key === statusKey}
              onClick={() => handleTabOnClick(key)}
            >
              {label}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
    );
  };

  const handleVoucherPagination = (page) => {
    if (selectedTierId) {
      searchByTier(page, selectedTierId);
    } else if (searchKey) {
      searchVoucherById(page);
    } else {
      getVoucherDetails(page);
    }
    setState({
      currentPage: page,
    });
  };

  const handleOnClick = (id) => {
    const rowData = voucherData.find((data) => data.id === id);
    setState({
      showVoucherDrawer: true,
      drawerData: rowData,
      voucherId: rowData.id,
      voucherExpiryDate: rowData.expiryDate,
      // Reset transaction-related state for new row
      showTransactions: false,
      transactionDetails: [],
      selectedTransaction: null,
      selectedRedemptionId: null,
    });
  };

  const handleDrawerOnHide = () => {
    setState({
      showVoucherDrawer: !showVoucherDrawer,
      // Clear transaction-related state when closing drawer
      transactionDetails: [],
      showTransactions: false,
      selectedTransaction: null,
      selectedRedemptionId: null,
    });
  };

  const handleReceiverChange = ({ target: { value } }) => {
    if (/^([a-zA-Z][a-zA-Z]*(\s[a-zA-Z]*)?)?$/.test(value)) {
      setState({
        receiverName: value,
      });
    }
  };

  const renderDrawer = () => {
    const handleRowClick = (rowOrId) => {
      if (rowOrId === null || rowOrId === undefined) return;

      let redemptionId = null;

      if (typeof rowOrId === 'object') {
        redemptionId = rowOrId.redemptionId || rowOrId.id || null;
      } else {
        redemptionId = rowOrId;
      }

      // try to find by redemptionId or id using loose equality to handle string/number mismatch
      let transaction = transactionDetails.find((t) => {
        try {
          return (
            String(t.purchaseId) === String(redemptionId) ||
            String(t.redemptionId) === String(redemptionId) ||
            String(t.id) === String(redemptionId)
          );
        } catch (e) {
          return false;
        }
      });

      // If not found and rowOrId is a numeric index, try index lookup
      if (!transaction && typeof rowOrId === 'number') {
        const idx = rowOrId;
        if (transactionDetails[idx]) {
          transaction = transactionDetails[idx];
          redemptionId = transaction.redemptionId || transaction.id;
        }
      }

      // As a fallback attempt, match by stringified values for any common fields
      if (!transaction) {
        transaction = transactionDetails.find((t) => {
          try {
            return (
              String(t.redemptionId) === String(redemptionId) ||
              String(t.id) === String(redemptionId) ||
              String(t.referenceCode) === String(redemptionId)
            );
          } catch (e) {
            return false;
          }
        });
      }

      if (transaction) {
        setState({
          selectedTransaction: transaction,
          selectedRedemptionId: redemptionId,
        });
      } else {
        // eslint-disable-next-line no-console
        console.warn('Transaction not found for id:', redemptionId, 'available:', transactionDetails);
      }
    };

    const data = drawerData;
    const voucherID = data.id;
    const primaryContent = [
      {
        label: 'Date Created',
        value: moment(data.createdDate)
          .add(5, 'hours')
          .add(30, 'minutes')
          .format('DD/MM/YYYY hh:mm A'),
      },
      {
        // conditionalRender: true,
        label: 'Expiry Date',
        value: moment(data.expiryDate).format('YYYY-MM-DD HH:mm:ss'),
      },
      {
        label: 'Status',
        value: data.status.toUpperCase(),
        style: data.status === 'EXPIRED' ? { color: 'red' } : null,
      },
      // {
      //   label: 'Sender Name',
      // },
      {
        label: 'Member Name',
        value: data.ownerName,
      },
      {
        label: 'Member Mobile No.',
        value: <span>{data.ownerMobile}</span>,
      },
    ];

    return (
      <div className='purchase_drawer_root'>
        <div className='drawer_child'>
          <div className='header_group'>
            <span className='header_title'>Reward ID</span>
            <span className='header_value'>{voucherID}</span>
          </div>
          {selectedTransaction ? (
            renderTransactionDetails(selectedTransaction)
          ) : (
            <>
              {showTransactions ? (
                <div className={`details_group ${styles.content}`}>
                  <DataTable
                    tableData={transactionDetails}
                    tableheading={transactionHeading}
                    handleOnClick={handleRowClick}
                    tag='transactionDetails'
                    fetchError={transactionError}
                    search_filter_loading={transactionLoading}
                  />
                </div>
              ) : (
                renderVoucherDetails(primaryContent)
              )}
            </>
          )}
          <div className='footer' style={{ padding: '0 15px' }}>
            <div
              className='button-container'
              style={{ display: 'flex', gap: '10px' }}
            >
              <Button
                variant='success'
                style={{ flex: selectedTransaction ? '1' : 'auto' }}
                onClick={() => {
                  if (showTransactions) {
                    setState({
                      showTransactions: false,
                      selectedTransaction: null,
                    });
                  } else {
                    getTransactionDetails(voucherID);
                  }
                }}
              >
                {showTransactions ? 'GO BACK' : 'View Point Account History'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderVoucherDetails = (data) => {
    return (
      <div className={`details_group ${styles.content}`}>
        <Card>
          <Card.Body>
            {data.map((item) => {
              return (
                <div className='detail_group_content'>
                  <span className='content_header'>{item.label}</span>
                  <span
                    className='content_value'
                    style={item.style && item.style}
                  >
                    {item.conditionalRender && (
                      <FontAwesomeIcon
                        className={styles.edit__icon}
                        icon={faEdit}
                        onClick={toggleExtensionModal}
                      />
                    )}
                    {item.value ? item.value : 'N/A'}
                  </span>
                </div>
              );
            })}
          </Card.Body>
        </Card>
      </div>
    );
  };

  return (
    <div className={styles.root_div}>
      <div>
        <PageHeader text='Point Accounts' />
        {/* <div className={styles.filter_block_status}>
          <span>Filter by status</span>
          {renderFilterByStatus()}
        </div> */}
        <div className={styles.toolbar_row}>
          <div className={styles.filter_row}>
            <div className={styles.tier_filter}>{renderTierFilter()}</div>
            <div className={styles.search_area}>{renderMultipleSearch()}</div>
          </div>
          <div className={styles.actions_area}>
            {checkedRows.length > 0 && (
              <div className='d-flex align-items-center mb-2'>
                <span style={{ lineHeight: '24px' }}>
                  {checkedRows.length}{' '}
                  point account
                  {checkedRows.length > 1 ? 's' : ''} selected
                </span>
                <span>
                  <CloseButton
                    className='ml-2'
                    onClick={() => {
                      setState({ checkedRows: [], selectAll: false });
                    }}
                  />
                </span>
              </div>
            )}
            <div className={styles.download_button_block}>
              <div className={styles.download_buttons_row}>
                <>
                  <Button
                    variant='secondary'
                    onClick={handleDownload}
                    disabled={downloadStatus === 'DOWNLOADING' || downloadStatus === 'DOWNLOADING_SELECTED'}
                  >
                    {downloadStatus === 'DOWNLOADING' ? 'Downloading...' : (isAnyFilterActive ? 'Download' : 'Download All')}
                  </Button>
                  {checkedRows.length > 0 && (
                    <Button
                      variant='secondary'
                      onClick={handleDownloadSelected}
                      disabled={downloadStatus === 'DOWNLOADING' || downloadStatus === 'DOWNLOADING_SELECTED'}
                    >
                      {downloadStatus === 'DOWNLOADING_SELECTED'
                        ? 'Downloading...'
                        : `Download Selected (${checkedRows.length})`}
                    </Button>
                  )}
                </>
              </div>
              {downloadStatus === 'ERROR' && (
                <span className={styles.download_error}>
                  Something went wrong. Please try again.
                </span>
              )}
            </div>
          </div>
        </div>

        <div>
          <CheckableDataTable
            tableData={voucherData}
            tableheading={tableHeading}
            isSelected={isSelected}
            tag='voucher-details'
            fetchError={fetchError}
            notFoundMessage={fetchError}
            search_filter_loading={loading}
            searchFilterLoading={false}
            handleOnClick={handleOnClick}
            handleCheck={handleCheckBoxToggle}
            handleSelectAll={handleSelectAll}
            handleMultipleCheck={handleMultipleCheck}
            checkedRows={checkedRows}
            selectAll={selectAll}
            isDemoUser={true}
          />
          {!loading && !fetchError && (
            <Pagination
              pageCount={totalPages}
              onChange={handleVoucherPagination}
              currentPage={currentPage}
            />
          )}
        </div>
      </div>
      <Drawer show={showVoucherDrawer} onHide={handleDrawerOnHide}>
        {drawerData && renderDrawer()}
      </Drawer>
      <VoucherActivationModal
        showModal={true}
        handleSubmit={handleActivationSubmit}
        showActivationModal={showActivationModal}
        loading={activationLoading}
        mobileError={mobileError}
        validated={validated}
        activationError={activationError}
        handleClose={hideActivationModal}
        receiverName={receiverName}
        receiverMobile={receiverMobile}
        handleReceiverChange={handleReceiverChange}
        handleMobileChange={handleMobileChange}
        voucherId={voucherId}
        activationSuccess={activationSuccess}
      />
      <VoucherExtensionModal
        showActivationModal={showExtensionModal}
        handleClose={toggleExtensionModal}
        voucherId={voucherId}
        token={props.auth.auth.token}
        voucherExpiryDate={voucherExpiryDate}
        searchId={searchId}
        getVoucherDetails={getVoucherDetails}
        searchVoucherById={searchVoucherById}
      />
      <MerchantCodesModal
        showMerchantCodesModal={showMerchantCodesModal}
        handleModalClose={handleMerchantModalClose}
        token={props.auth.auth.token}
        redemptionId={selectedRedemptionId}
        handlemodalclose={handleMerchantModalClose}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    role: state.auth.auth.details.role,
  };
};
export default connect(mapStateToProps)(ViewVouchers);
